import React from 'react';
import HelpLink from '~/components/Links/HelpLink';
import HelpIcon from '~/public/static/svg/HelpIcon';

interface Props {}

export function ZipPayIcon() {
  return (
    <svg
      width="50"
      height="auto"
      viewBox="0 0 300 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-description="Zip Pay"
    >
      <path
        d="M300 20C300 8.9543 291.046 0 280 0H20C8.9543 0 0 8.95431 0 20V115C0 126.046 8.95431 135 20 135H280C291.046 135 300 126.046 300 115V20Z"
        fill="#1A0826"
      />
      <path
        d="M117.043 46.5264L123.925 102.52H191.223L184.34 46.5264H117.043Z"
        fill="#AA8FFF"
      />
      <path
        d="M136.241 25.159C140.533 29.1942 141.122 35.5407 137.556 39.3346C133.99 43.1285 127.619 42.9328 123.327 38.8977C119.035 34.8626 118.446 28.5161 122.012 24.7222C125.578 20.9284 131.949 21.1239 136.241 25.159Z"
        fill="#FFFFFA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M261.751 66.6885C260.202 54.0955 250.31 46.4822 236.877 46.5264H192.13L199.012 102.52H219.151L217.779 91.3212H239.09C255.842 91.3212 263.521 80.8749 261.751 66.6885ZM236.899 75.6298L215.831 75.6519L214.171 62.2179L235.35 62.24C240.329 62.3064 242.874 65.095 243.295 68.9459C243.56 71.4026 242.431 75.6298 236.899 75.6298Z"
        fill="#FFFFFA"
      />
      <path
        d="M46.9571 86.8728L48.8824 102.52H116.113L113.9 84.6153H82.5643L82.2766 82.38L111.156 62.218L109.231 46.5265H42L44.1909 64.4532H75.5934L75.8811 66.6886L46.9571 86.8728Z"
        fill="#FFFFFA"
      />
    </svg>
  );
}

// The little blue-background quadpay thing with their icon in it.
const ZipPayLinkAndIcon: React.FC<Props> = () => (
  <HelpLink
    link="zipPay"
    title="Learn more about Zip"
    className="mb-0.5 inline-flex items-center space-x-2"
  >
    <ZipPayIcon />

    <HelpIcon />
  </HelpLink>
);

export default ZipPayLinkAndIcon;
